import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productSetupCheck'
})
export class ProductSetupCheckPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value == null){
      value = false
    }
    return value;
  }

}
